const countries = ['France', 'Royaume-Uni', 'Allemagne', 'Italie', 'Suisse', 'Espagne']

export default countries


// WEBPACK FOOTER //
// ./src/fixtures/countries.js